import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import CompliancePage from "@/pages/CompliancePage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminDocuments from "@/pages/admin/AdminDocuments";
import AdminBroadcasts from "@/pages/admin/AdminBroadcasts";
import AdminBulkImport from "@/pages/admin/AdminBulkImport";
import AdminBulkOffers from "@/pages/admin/AdminBulkOffers";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminExecutive from "@/pages/admin/AdminExecutive";
import AdminCampaignDiag from "@/pages/admin/AdminCampaignDiag";
import AdminCompliance from "@/pages/admin/AdminCompliance";

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
      </Routes>
      <Footer />
      <ChatWidget />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="clients" element={<AdminClients />} />
          <Route path="clients/import" element={<AdminBulkImport />} />
          <Route path="offers" element={<AdminOffers />} />
          <Route path="offers/bulk" element={<AdminBulkOffers />} />
          <Route path="documents" element={<AdminDocuments />} />
          <Route path="broadcasts" element={<AdminBroadcasts />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="campaign-diagnostics" element={<AdminCampaignDiag />} />
          <Route path="quotes" element={<AdminQuotes />} />
          <Route path="compliance" element={<AdminCompliance />} />
          <Route path="executive" element={<AdminExecutive />} />
          <Route path="suppliers" element={<AdminSuppliers />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    );
  }

  return <PublicLayout />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
